<section class="feature-introductions-item-container">
    <section *ngIf="icon" class="feature-introductions-item-heading">
        <img class="feature-introductions-item-icon" [ngSrc]="icon | staticServe" width="24" height="24"> 
        <section>
            <div *ngIf="title" class="feature-introductions-item-title">{{title}}</div>
            <div *ngIf="description" class="feature-introductions-item-description">{{description}}</div>
        </section>
    </section>

</section>